import { render, staticRenderFns } from "./ResultCell.vue?vue&type=template&id=da640f14&scoped=true&"
import script from "./ResultCell.vue?vue&type=script&lang=js&"
export * from "./ResultCell.vue?vue&type=script&lang=js&"
import style0 from "./ResultCell.vue?vue&type=style&index=0&id=da640f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da640f14",
  null
  
)

export default component.exports